<template>

    <div class="face-rate" :class="{loading: signInLoading}">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <h4 class="login_msg" v-if="mgs && mgs !== ''">{{mgs}}</h4>
        <div class="rateMassage">
            <div class="page-spinner">
                <b-spinner v-if="signInLoading" style="width: 3rem; height: 3rem;" type="grow"
                           label="Spinning"></b-spinner>
            </div>
            <div class="header-logo">
                <a @click="homePage">
                    <img src="@/assets/icons/login__logo.svg" alt="">
                </a>
            </div>
            <div class="button-group-login">
                <div class="form">
                    <div v-show="showLoginForm" class="login-form">
                        <div class="register-top__wrapper">
                            <div class="title-wrapper">
                                <a :class="{active: this.currentForm == 'login'}" @click.prevent="toggleForm('login')"
                                   class="sign-in__title" href="#">{{translate('signIn_signIn_title')}}</a>
                                <a :class="{active: this.currentForm == 'register'}"
                                   @click.prevent="toggleForm('register')"
                                   class="sing-up__title" href="#">{{translate('signIn_signUp_title')}}</a>
                            </div>
                            <div class="button-group">
                                <button class="google-btn">
                                    <div @click="onGoogleSingIn">
                                        <div class="google-btn__content">
                                            <div class="google-btn__icon"><img src="@/assets/icons/ic_google_logo.svg"
                                                                               alt=""></div>
                                            <div class="facebook-btn__text">{{translate('signIn_Login', ['Google'])}}</div>
                                        </div>
                                    </div>
                                </button>
                                <button @click="onFacebookSignIn" class="facebook-btn">
                                    <div v-if="loadingFacebookSpinner">
                                        <div class="facebook-btn__content">
                                            <div class="facebook-btn__icon"><img
                                                    src="@/assets/icons/ic_facebook_logo.svg" alt=""></div>
                                            <div class="facebook-btn__text">{{translate('signIn_Login', ['Facebook'])}}</div>
                                        </div>
                                    </div>
                                    <div v-else class="spinner">
                                        <b-spinner style="width: 3rem; height: 3rem;" type="grow"
                                                   label="Spinning"></b-spinner>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div class="button-group__subtitle">{{translate('signIn_enter_using_email')}}</div>
                        <form class="sign-in__form">
                            <div class="sign-in__wrapper">
                                <div class="input-wrapper">
                                    <div class="input-icon"><i class="fas fa-envelope"></i></div>
                                    <input id="email" class="sign-input" type="email" v-model="signIn.email" required>
                                    <label class="form-lable">{{translate('signIn_email_hint')}}</label>
                                </div>
                                <div class="input-wrapper">
                                    <div class="input-icon"><i class="fas fa-unlock-alt"></i></div>
                                    <input class="sign-input" :type="type" v-model="signIn.password" required>
                                    <label class="form-lable">{{translate('signIn_password_hint')}}</label>
                                    <div class="show-password" @click="showPassword">
                                        <div class="show-password__icon" v-if="type === 'password'">
                                            <i class="far fa-eye"></i>
                                        </div>
                                        <div v-else>
                                            <i class="far fa-eye-slash"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="input-btn__wrapper">
                                <a @click="logInEmail" class="sign-in__button">{{translate('signIn_signInBtn')}}</a>
                                <a @click.prevent="toggleForm('forgot')" class="forgot__button">{{translate('signIn_forgotPass_btn')}}</a>
                            </div>
                        </form>
                    </div>
                    <div v-show="showRegisterForm" class="register-form">
                        <div class="register-top__wrapper" v-if="loginQuestion">
                            <div class="title-wrapper">
                                <div class="register-title">
                                    {{translate('signIn_TitleWithQuestion')}}
                                </div>
                            </div>
                            <div class="register-content">
                                <div class="register-content__icon">
                                    <img src="@/assets/icons/ic_success-yellow.svg">
                                </div>
                                <div class="register-content__text">
                                    {{translate('signIn_ChecklistFirst')}}
                                </div>
                            </div>
                            <div class="register-content">
                                <div class="register-content__icon">
                                    <img src="@/assets/icons/ic_success-yellow.svg">
                                </div>
                                <div class="register-content__text">
                                   {{translate('signIn_ChecklistSecond')}}
                                </div>
                            </div>
                            <div class="social-group__btn">
                                <button class="google-btn">
                                    <div @click="onGoogleSingIn">
                                        <div class="google-btn__content">
                                            <div class="google-btn__icon"><img src="@/assets/icons/ic_google_logo.svg" alt=""></div>
                                            <div class="google-btn__text">{{translate('signIn_Register', ['Google'])}}</div>
                                        </div>
                                    </div>
                                </button>
                                <button @click="onFacebookSignIn" class="facebook-btn">
                                    <div v-if="loadingFacebookSpinner">
                                        <div class="facebook-btn__content">
                                            <div class="facebook-btn__icon"><img src="@/assets/icons/ic_facebook_logo.svg" alt=""></div>
                                            <div class="facebook-btn__text">{{translate('signIn_Register', ['Facebook'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="spinner">
                                        <b-spinner style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <div class="register-top__wrapper" v-else>
                            <div class="title-wrapper">
                                <a :class="{active: this.currentForm == 'login'}" @click.prevent="toggleForm('login')"
                                   class="sign-in__title" href="#">{{translate('signIn_signIn_title')}}</a>
                                <a :class="{active: this.currentForm == 'register'}"
                                   @click.prevent="toggleForm('register')"
                                   class="sing-up__title" href="#">{{translate('signIn_signUp_title')}}</a>
                            </div>
                            <div class="button-group__subtitle">{{translate('signIn_noCreditReq')}}</div>
                            <div class="social-group__btn">
                                <button class="google-btn">
                                    <div @click="onGoogleSingIn">
                                        <div class="google-btn__content">
                                            <div class="google-btn__icon"><img src="@/assets/icons/ic_google_logo.svg"
                                                                               alt=""></div>
                                            <div class="google-btn__text">{{translate('signIn_Register', ['Google'])}}</div>
                                        </div>
                                    </div>
                                </button>
                                <button @click="onFacebookSignIn" class="facebook-btn">
                                    <div v-if="loadingFacebookSpinner">
                                        <div class="facebook-btn__content">
                                            <div class="facebook-btn__icon"><img
                                                    src="@/assets/icons/ic_facebook_logo.svg" alt=""></div>
                                            <div class="facebook-btn__text">{{translate('signIn_Register', ['Facebook'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="spinner">
                                        <b-spinner style="width: 3rem; height: 3rem;" type="grow"
                                                   label="Spinning"></b-spinner>
                                    </div>
                                </button>
                            </div>
                        </div>
                        <form class="sign-up__form">
                            <div class="or__wrapper">
                                <span class="separator"></span>
                                <span class="separator-text">{{translate('signIn_SeparatorText')}}</span>
                                <span class="separator"></span>
                            </div>
                            <div class="sign-up__title">
                                {{translate('signIn_RegisterWithEmail')}}
                            </div>
                            <div class="sign-up__wrapper">
                                <div class="input-wrapper">
                                    <div class="input-icon"><i class="fas fa-user"></i></div>
                                    <input class="sign-input" type="text" v-model="signUp.first_name" required>
                                    <label class="form-lable">{{translate('signIn_firstName_hint')}}</label>
                                </div>
                                <div class="input-wrapper">
                                    <div class="input-icon__last-name"><i class="fas fa-user"></i></div>
                                    <input class="sign-input" type="text" v-model="signUp.last_name" required>
                                    <label class="form-lable__last-name">{{translate('signIn_lastName_hint')}}</label>
                                </div>
                            </div>
                            <div class="input-wrapper">
                                <div class="input-icon"><i class="fas fa-envelope"></i></div>
                                <input class="sign-input" type="email" v-model="signUp.email" required>
                                <label class="form-lable">{{translate('signIn_email_hint')}}</label>
                            </div>
                            <div class="input-wrapper">
                                <div class="input-icon"><i class="fas fa-unlock-alt"></i></div>
                                <input class="sign-input" :type="type" v-model="signUp.password"
                                       @focus="onPasswordFocus"
                                       @blur="onPasswordFocusLost" required>
                                <label class="form-lable">{{translate('signIn_password_hint')}}</label>
                                <div class="show-password" @click="showPassword">
                                    <div class="show-password__icon" v-if="type === 'password'">
                                        <i class="far fa-eye"></i>
                                    </div>
                                    <div v-else>
                                        <i class="far fa-eye-slash"></i>
                                    </div>
                                </div>
                            </div>
                            <passwordValidation :settings='passwordValidationSettings'></passwordValidation>
                            <div class="checkBox-wrapper">
                                <input class="sign-up__checkbox" id="Terms" name="" type="checkbox"
                                       v-model="termsCheckbox"
                                       true-value="yes"
                                       false-value="no">
                                <label class="checkbox-title" for="Terms" id="checkbox-text">{{translate('signIn_agreeTo')}}
                                    <a
                                            @click="this.onTCClick" class="privecy" target="_blank">{{translate('signIn_tAndC')}}</a></label>
                            </div>
                            <div class="sign-btn__wrapper" v-if="termsCheckbox === 'yes'">
                                <a @click="signUpUser" class="sign-up__button" v-if="!loginQuestion">{{translate('signIn_signUp_btn')}}</a>
                                <a @click="signUpUser" class="sign-up__button" v-if="loginQuestion">{{translate('signIn_RegisterWithQuestion')}}</a>
                            </div>
                            <div class="sign-btn__wrapper" v-else>
                                <button @click="signUpUser" class="sign-up__button" v-if="!loginQuestion" disabled>{{translate('signIn_signUp_btn')}}</button>
                                <button @click="signUpUser" class="sign-up__button" v-if="loginQuestion" disabled>{{translate('signIn_RegisterWithQuestion')}}</button>
                            </div>
                            <div class="google-policy__wrapper">
                                {{translate('signIn_protected')}}<a class="policy-link"
                                                                    href="https://policies.google.com/privacy"
                                                                    target="_blank">
                                {{translate('signIn_privacyPolice')}}</a> {{translate('signIn_and')}}
                                <a class="policy-link" href="https://policies.google.com/terms" target="_blank">{{translate('signIn_Terms')}}</a>
                            </div>
                        </form>
                    </div>
                    <div v-show="showForgotForm" class="reset-password">
                        <div class="reset-password__wrapper">
                            <div class="reset-title">
                                {{translate('signIn_recoverPassword')}}
                            </div>
                            <div class="reset-subtitle">
                                {{translate('signIn_recoverPassSubtitle')}}
                            </div>
                            <form class="reset-form">
                                <div class="input-wrapper">
                                    <div class="input-icon"><i class="fas fa-envelope"></i></div>
                                    <input class="sign-input" type="text" v-model="signUp.email" required>
                                    <label class="form-lable">{{translate('signIn_email_hint')}}</label>
                                </div>
                                <a @click="onContinueBtnClick" class="reset-btn">{{translate('signIn_recoverPassContinue')}}</a>
                            </form>
                            <div class="return-btn__wrapper">
                                <a @click.prevent="toggleForm('login')" class="return-btn">{{translate('signIn_recoverPassBack')}}</a>
                            </div>

                        </div>
                    </div>
                </div>
                <!--                <facebook-login class="button" appId="770275700057951" @sdk-loaded="sdkLoaded" hidden></facebook-login>-->
                <v-facebook-login app-id="770275700057951" @sdk-init="sdkLoaded" hidden></v-facebook-login>

            </div>
            <div class="contact">
                {{translate('signIn_difficulties')}} <br>
                {{translate('signIn_contact')}} <span><a class="contact-link" href="mailto:team@air-vote.com">team@air-vote.com</a></span>
            </div>
            <div class="language-change">
                <ul class="language-list">
                    <li @click="changeLanguage(lang)" class="language-icon"
                        :key="lang"
                        :style="{
                                              backgroundImage: 'url(' + require('@/assets/' + lang + '.png') + ')'
              }"
                        v-for="(lang) in $ml.list"></li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';
    import errorMixin from '@/mixins/errorMixin';
    import logAnalyticsEvent, {logError} from '@/helpers/analytics'
    import config from '@/api/config';
    import passwordValidation from "@/components/widgets/passwordValidation";
    import customModalDialog from '@/components/widgets/customModalDialog';


    export default {
        name: 'login',

        mixins: [mixin, errorMixin],


        data() {
            return {
                termsCheckbox: false,
                signInLoading: false,
                mgs: null,
                error_obj: this.$route.params.error_obj,
                langSelect: this.$ml.current,
                currentForm: 'login',
                loginQuestion: false,
                signIn: {
                    email: this.$route.query.email,
                    password: '',
                },
                signUp: {
                    email: this.$route.query.email,
                    first_name: this.$route.query.first_name,
                    last_name: this.$route.query.last_name,
                    password: '',
                },
                passwordValidationSettings: {
                    validation: '',
                    show: false,
                },
                type: 'password',
                customModalSettings: null,

            }
        },
        components: {
            passwordValidation,
            customModalDialog
        },

        async beforeMount() {
            const path = this.$route.path
            if (path.includes('sign-in')) {
                this.currentForm = 'login'
            } else if (path.includes('sign-up')) {
                this.currentForm = 'register'
            } else if (path.includes('forgot-password')) {
                this.currentForm = 'forgot'
            }
            if(this.$route.query.type && this.$route.query.type == 'linkQuestion') {
                this.mgs = this.translate('sign_in_to_connect')
            }

        },

        async mounted() {
            if (this.$route.params.provider === 'google') {
                this.GoogleSignIn({becomeOwner: true})
            } else if (this.$route.params.provider === 'fb') {
                this.FacebookSignIn({becomeOwner: true})
            }
            if (this.$route.params.questions) {
                try {
                    let obj = JSON.parse(decodeURIComponent(this.$route.params.questions))
                    if (obj.quids || obj.text) {
                        localStorage.setItem('login_questions', JSON.stringify(obj))
                        this.loginQuestion = true
                        console.log(this.loginQuestion)
                    }
                } catch (e) {
                }
            }
            if (localStorage.getItem('access_token') != undefined) {
                this.handleUserFlow()
                return
            }
            if (this.error_obj != undefined) {
                this.showErrorModal(this.error_obj.message)
                return
            }
            this.setLanguage(this.$ml.current)
        },

        watch: {
            'signUp.password'(item) {
                this.passwordValidationSettings.validation = item
            },
        },

        computed: {
            ...mapGetters({
                isUserClient: 'auth/isUserClient',
                isUserOwner: 'auth/isUserOwner',
                getUserOrgIds: 'auth/getUserOrgIds',
                isUserAdmin: 'auth/isUserAdmin',
                isUserDriver: 'auth/isUserDriver',
                getOwnPlace: 'auth/getOwnPlace',
                isUserOrgManager: 'auth/isUserOrgManager',
                isUserSiteManager: 'auth/isUserSiteManager',
                getFormatedLang: 'getFormatedLang'
            }),
            showRegisterForm() {
                return this.currentForm === 'register';
            },
            showLoginForm() {
                return this.currentForm === 'login';
            },
            showForgotForm() {
                return this.currentForm === 'forgot';
            }

        },
        methods: {
            ...mapMutations({
                setLanguage: 'setLanguage',
                setProgressBarTag: 'setProgressBarTag',
            }),
            ...mapActions({
                updateProfileLang: 'profiles/updateProfileLang',
                logIn: 'auth/logIn',
                resetPassword: 'auth/resetPassword',
                registration: 'auth/registration'
            }),

            async onFacebookSignIn() {
                logAnalyticsEvent(`signin_loginfb`)
                await this.FacebookSignIn({
                    becomeOwner: true,
                    redirect: false
                })
                this.handleUserFlow()
            },

            async onGoogleSingIn() {
                await this.GoogleSignIn({
                    becomeOwner: true,
                    redirect: false
                })
                logAnalyticsEvent(`signin_logingg`)
                this.handleUserFlow()
            },
            async logInEmail() {
                logAnalyticsEvent(`signin_login_email_click`)
                let recaptchaToken = await this.reCaptcha('login')
                const body = {
                    email: this.signIn.email,
                    password: this.signIn.password,
                    captcha_token: recaptchaToken,
                    start_tpl_uids: this.getStartQuestionUids(),
                    start_tpl_text: this.getStartQuestionText(),
                }
                this.showLoader(true)
                try {
                    const response = await this.logIn(body)
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                        await this.tryChangeUserStatus()
                        logAnalyticsEvent(`signin_login_email_success`)
                        this.handleUserFlow()
                    }
                } catch (e) {
                    logError('signin_login_email_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.showLoader(false)
                }
            },

            getStartQuestionUids() {
                var questionsUids = []
                try {
                    questionsUids = JSON.parse(localStorage.getItem('login_questions')).quids
                } catch {
                }
                return questionsUids
            },
            getStartQuestionText() {
                try {
                    let text = JSON.parse(localStorage.getItem('login_questions')).text
                    if(text != null && text != '') {
                        return text
                    }
                } catch {
                }
                return null
            },

            async signUpUser() {
                logAnalyticsEvent(`signin_register_create_acc_click`)
                if (!this.termsCheckbox) {
                    return
                }
                let recaptchaToken = await this.reCaptcha('signup')

                const body = {
                    email: this.signUp.email,
                    first_name: this.signUp.first_name,
                    last_name: this.signUp.last_name,
                    password: this.signUp.password,
                    captcha_token: recaptchaToken,
                    start_tpl_uids: this.getStartQuestionUids(),
                    start_tpl_text: this.getStartQuestionText(),
                }
                this.showLoader(true)
                try {
                    const response = await this.registration(body)
                    if (response.data.access_token && response.data.refresh_token) {
                        this.setSignInState(response)
                        await this.tryChangeUserStatus()
                        logAnalyticsEvent(`signin_register_create_acc_success`)
                        this.handleUserFlow()
                    }
                } catch (e) {
                    logError('signin_register_create_acc_error', e.data.error.message || '')
                    this.showErrorModal(e.data.error.message, {
                        title: 'Error',
                        code: e.data.error.code
                    })
                } finally {
                    this.showLoader(false)
                }

            },
            getRedirectUrl() {
                let url = decodeURIComponent(this.$route.query.redirect_url)
                console.log(`decoded: ${url}`)
                if(url != '' && (url.includes('http://') || url.includes('https://'))) {
                    return url
                } else {
                    return null
                }
            },
            handleUserFlow() {
                let redirectUrl = this.getRedirectUrl()
                if (this.isUserAdmin) {
                    if(redirectUrl) {
                        window.open(redirectUrl,"_self")
                    } else {
                        this.$router.push('/admin')
                    }
                } else if ((this.isUserOwner && this.getOwnPlace) || (this.isUserOrgManager || this.isUserSiteManager)) {
                    if(redirectUrl) {
                        window.open(redirectUrl,"_self")
                    } else {
                        if(this.getUserOrgIds.includes(719)) { //republic services
                            this.$router.push({name: 'ServiceLogsDashboard'})
                        } else {
                            this.$router.push({name: 'OwnerPlaceManagement', params: {analyticActiveBool: true}})
                        }
                    }
                } else if (this.isUserOwner && !this.getOwnPlace) {
                    this.$store.commit('owner/setOwner', true)
                    this.$router.push({name: 'ownerBusinessFlow'});
                } else if (this.isUserDriver) {
                    this.$router.push({name: 'driverFlow'});
                }
            },
            changeLanguage(lang) {
                this.$ml.change(lang)
                this.changelang()
            },
            changelang() {
                logAnalyticsEvent('lang_click', {
                    lang: this.$ml.current,
                    source: 'login'
                })
                this.langShow = !this.langShow
                this.langSelect = this.$ml.current;
                this.setLanguage(this.$ml.current)
                this.updateLanguage()
            },
            async updateLanguage() {
                const response = await this.updateProfileLang(localStorage.getItem('lang'))
            },
            toggleForm(formName) {
                this.currentForm = formName;
                this.updateRouteForForm(formName)
                if (formName === 'forgot') {
                    logAnalyticsEvent(`signin_login_forgot_click`)
                }
            },

            updateRouteForForm(formName) {
                var routeName = 'sign-in'
                switch (formName) {
                    case 'login': {
                        routeName = 'sign-in'
                        break
                    }
                    case 'register': {
                        routeName = 'sign-up'
                        break
                    }
                    case 'forgot': {
                        routeName = 'forgot-password'
                        break
                    }
                }
                this.$router.replace('/' + routeName)
            },

            onTCClick() {
                window.open(`${config.siteUrl}/${this.$ml.current}/terms/`, '_blank').focus()
            },

            showLoader(show) {
                this.signInLoading = show
            },
            homePage() {
                window.open(`${config.siteUrl}/${this.$ml.current}`, '_blank').focus()
            },
            showPassword() {
                if (this.type === 'password') {
                    this.type = 'password-text'
                } else {
                    this.type = 'password'
                }
            },

            onPasswordFocus() {
                this.passwordValidationSettings.show = true
            },

            onPasswordFocusLost() {
                this.passwordValidationSettings.show = this.signUp.password !== ''
            },
            onContinueBtnClick() {
                this.resetPasswordAction()
            },
            async resetPasswordAction() {
                let recaptchaToken = await this.reCaptcha('login')
                const body = {
                    email: this.signUp.email,
                    captcha_token: recaptchaToken
                }
                try {
                    this.setProgressBarTag({
                        show: true,
                        tag: 'resetPasswordRequest'
                    })
                    const response = await this.resetPassword(body)
                    if (response) {
                        this.customModalSettings = {
                            title: this.translate('signIn_LookAtEmail'),
                            onOkHandler: this.toggleForm('login')
                        }
                    }
                } catch (e) {
                    console.log('Error')
                } finally {
                    this.setProgressBarTag({
                        show: false,
                        tag: 'resetPasswordRequest'
                    })
                }
            },


        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .password-icons {
        margin-top: -20px;
        margin-left: 25px;
        flex-direction: column;
    }

    .password-icon-row .input-icon {
        margin-top: 0;
    }

    .password-icon-row {
        display: flex;
        color: #e5e5e5;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
        font-family: 'Nunito';
    }

    .password-icon-row .icon-active {
        color: #36BC00;
    }

    .password-icon-row .icon-inactive {
        color: #FD4315;
    }

    .header-logo {
        margin-top: 14px;
        cursor: pointer;
        margin-bottom: 26px;
    }

    .face-rate {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        min-height: 100vh;
        padding-left: 5vw;
        padding-right: 5vw;
        /*padding-bottom: 15vh;*/
        text-align: center;
        background: #F3F3F3;
    }

    .face-rate.loading {
        background: #9d9d9d;
    }

    .face-rate.loading .button-group-login {
        opacity: 0.2;
    }

    .face-rate h4 {
        color: #fff;
    }

    .face-container {
        background: #fff;
        -webkit-border-radius: 1em;
        -moz-border-radius: 1em;
        border-radius: 1em;
        padding: 2em 0;
        box-shadow: 0em 0.05em 1em 0em rgba(0, 0, 0, .6);
        width: 100%;
    }

    .face-container ul {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin: 0;
    }

    .face-container ul li {
        min-width: 20vw;
        max-width: 300px;
    }

    .face-rate h1,
    .face-rate h2 {
        color: #fff;
        margin-top: 1em;
    }

    .face-rate h2 {
        margin-top: 0;
        margin-bottom: 1em;
    }


    .button-group-login {
        display: flex;
        width: 594px;
        border-radius: 16px;
        background-color: #3F405C;
        padding-bottom: 40px;
    }

    .login-form {
        width: 550px;
    }

    .sign-in__form {
        padding-left: 48px;
    }

    .title-wrapper {
        display: flex;
        margin-left: 55px;
        padding-top: 54px;
    }

    .title-wrapper a {
        margin-right: 40px;
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 18px;
        text-decoration: none;
        outline: none;
    }

    .title-wrapper a:hover {
        border-bottom: 3px solid #FFBF00;
        border-radius: 1px;
        text-decoration: none;
        outline: none;
        cursor: pointer;
    }

    .title-wrapper a.active {
        border-bottom: 3px solid #FFBF00;
        border-radius: 1px;
        text-decoration: none;
        outline: none;
        cursor: pointer;
    }

    .button-group {
        display: flex;
        margin-top: 33px;
        margin-left: 50px;
        padding-bottom: 40px;
        margin-right: 20px;
        flex-direction: row;
    }

    .google-btn__icon {
        padding: 10px;
    }

    .google-btn__text {
        padding-right: 10px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        font-weight: bold;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
    }

    .facebook-btn__icon {
        padding: 10px;
    }

    .facebook-btn__text {
        padding-right: 10px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;

    }

    .button-group__subtitle {
        color: #FFFFFF;
        font-family: Nunito;
        font-weight: 700;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        margin-top: 32px;
        text-align: start;
        padding-left: 55px;
    }

    .sign-in__wrapper {
        margin-top: 30px;
    }

    .input-icon__last-name {
        display: none;
    }

    .input-wrapper {
        display: flex;
        margin-bottom: 32px;
        position: relative;
        vertical-align: top;
        padding-right: 48px;
    }

    .sign-input:focus ~ .form-lable,
    .sign-input:not(:focus):valid ~ .form-lable {
        font-size: 15px;
    }

    .sign-input:focus ~ .form-lable__last-name,
    .sign-input:not(:focus):valid ~ .form-lable__last-name {
        top: -20px;
        font-size: 15px;
    }

    .form-lable {
        position: absolute;
        pointer-events: none;
        left: 0;
        top: -20px;
        transition: .3s;
    }

    .form-lable__last-name {
        position: absolute;
        pointer-events: none;
        left: 0;
        top: 0;
        transition: .3s;
        padding-left: 0;
    }

    .input-icon {
        color: white;
        margin-right: 8px;
        height: 14px;
        width: 18px;
        margin-top: 3px;
    }

    input {
        outline: none;
        color: white;
        border: none;
        background-color: #3F405C;
    }

    input[type="text"] {
        width: 216px;
    }

    input[type="password"], input[type="email"], input[type="password-text"] {
        width: 288px;
    }

    input::-webkit-input-placeholder {
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus {
        -webkit-box-shadow: inset 0 0 0 50px #3F405C;
        -webkit-text-fill-color: white;
        transition: background-color 5000s ease-in-out 0s;
    }

    .sign-input {
        color: #FFFFFF;
        border-bottom: 3px solid #ffffff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-bottom: 5px;
    }

    .input-btn__wrapper {
        display: flex;
        flex-direction: column;
    }

    .sign-in__button {
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        text-align: center;
        border-radius: 6px;
        background-color: #FFBF00;
        box-shadow: 0 2px 8px 0 #FFBF00;
        padding: 12px 138px;
    }

    .sign-in__button:hover {
        cursor: pointer;
        text-decoration: none;
        outline: none;
    }

    .forgot__button {
        margin-top: 25px;
        color: #ffffff !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        height: 25px;
        width: 150px;
        margin-left: 175px;
    }

    .forgot__button:hover {
        cursor: pointer;
        color: #ffffff !important;
        text-decoration: none !important;
        outline: none !important;
    }

    .form {
        width: 100%;
    }

    .or__wrapper {
        display: flex;
        align-items: center;
    }

    .separator {
        height: 1px;
        background-color: white;
        width: 220px;
    }

    .separator-text {
        margin-right: 8px;
        margin-left: 8px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
    }

    .register-top__wrapper {
        background-color: #32324B;
        border-radius: 16px 16px 0 0;
        width: 594px;
    }
    .register-title {
        font-family: Nunito;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 28px;
        color: #ffffff;
    }
    .register-content {
        display: flex;
        align-items: center;
        margin-left: 55px;
        margin-top: 13px;
        margin-bottom: 8px;
    }
    .register-content__icon {
        margin-right: 10px;
    }
    .register-content__text {
        font-family: Nunito;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 24px;
        color: #ffffff;
        text-align: start;
    }
    .sign-up__form {
        margin-top: 8px;
        padding-left: 50px;
    }

    .sign-up__title {
        text-align: start;
        margin-top: 30px;
        margin-bottom: 33px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
    }

    .sign-up__wrapper {
        display: flex;
    }

    .checkBox-wrapper {
        display: flex;
    }

    input[type="checkbox"] {
        display: none;
    }

    label {
        margin-bottom: 0 !important;
        cursor: default;
        position: relative;
        width: 100%;
        color: #ffffff;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        padding-left: 30px;
        text-align: start;
    }

    label .checkbox-title {
        padding-left: 25px;
    }

    label.checkbox-title:before {
        content: " ";
        color: #000;
        display: inline-block;
        font: 15px/20px FontAwesome;
        position: absolute;
        top: 0;
        left: 0;
        text-align: center;
        background: linear-gradient(180deg, #3F405C 0%, #3F405C 100%);
        height: 22px;
        width: 22px;
        border: 2px solid #FFBF00;
        border-radius: 3px;
    }

    input:checked + label.checkbox-title:before {
        content: "\2714";
        background: #FFBF00;
    }

    .sign-btn__wrapper {
        margin-top: 30px
    }

    .sign-up__button {
        text-decoration: none;
        outline: none;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #FFBF00;
        box-shadow: 0 2px 8px 0 #FFBF00;
        padding: 12px 100px;
        width: 514px;
        cursor: pointer;
        border: none;
        display: block;
    }

    .sign-up__button:disabled {
        color: white;
        background-color: #2f2f2f;
        box-shadow: 0 2px 8px 0 #2f2f2f;
    }

    .sign-up__button:hover {
        text-decoration: none;
        outline: none;
        cursor: pointer;
    }

    .sign-up__subtitle {
        margin-top: 35px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
    }

    .social-group__btn {
        margin-top: 25px;
        padding-bottom: 40px;
    }

    .google-policy__wrapper {
        margin-bottom: 15px;
        margin-top: 15px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 14px;
        letter-spacing: 0;
        line-height: 24px;
        text-align: start;
    }

    .policy-link {
        color: #FFBF00;
        font-family: Nunito;
        font-size: 14px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
    }

    .policy-link:hover {
        text-decoration: none;
        outline: none;
    }

    .grecaptcha-badge {
        visibility: hidden;
    }

    .privecy {
        text-decoration: none;
        outline: none;
        color: #FFBF00;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
    }

    .privecy:hover {
        text-decoration: none;
        outline: none;
        color: #FFBF00;
        cursor: pointer;
    }

    .reset-password__wrapper {
        margin-top: 43px;
    }

    .reset-form .input-wrapper {
        margin-left: 128px;
    }

    .reset-form .input-wrapper input[type = "text"] {
        width: 300px;
    }

    .reset-title {
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 18px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 18px;
    }

    .reset-subtitle {
        margin-top: 40px;
        color: #FFFFFF;
        font-family: Nunito;
        font-size: 16px;
        letter-spacing: 0;
        line-height: 24px;
        padding-left: 25px;
        padding-right: 25px;
    }

    .reset-form {
        margin-top: 40px;
    }

    .reset-btn {
        margin-top: 36px;
        color: #2F2F2F;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        border-radius: 6px;
        background-color: #FFFFFF;
        box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.24);
        padding: 12px 120px;
    }

    .reset-btn:hover {
        text-decoration: none;
        color: #2f2f2f;
        outline: none;
        cursor: pointer;
    }

    .return-btn__wrapper {
        margin-top: 45px;
    }

    .return-btn {
        color: #FFBF00 !important;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
        cursor: pointer;
    }

    .return-btn:hover {
        text-decoration: none;
        color: #FFBF00 !important;
        outline: none;
    }

    .show-password {
        position: absolute;
        left: 290px;
        top: 4px;
        color: white;
    }


    .button-group-login button > div.spinner {
        justify-content: center;
        padding-right: 50px;
    }

    .button-group-login button.google-btn {
        border-radius: 6px;
        background-color: #D85140;
        margin-right: 16px;
        outline: none !important;
        border: none;
    }

    .button-group-login button.facebook-btn {
        border-radius: 6px;
        background-color: #1976D2;
        outline: none !important;
        border: none;
    }

    .google-btn__content {
        display: flex;
        align-items: center;
    }


    .facebook-btn__content {
        display: flex;
        align-items: center;
    }


    .contact {
        margin-top: 45px;
        margin-bottom: 71px;
        color: #3F405C;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        line-height: 24px;
    }

    .contact-link {
        color: #1976D2;
        text-decoration: none;
        font-family: Nunito;
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0;
        white-space: nowrap;
    }

    .contact-link:hover {
        text-decoration: none;
    }

    .language-change {
        margin-top: 20px;
    }

    .language-icon {
        background-size: contain;
        height: 31px;
        width: 31px;
    }

    @media screen and (max-width: 1440px) {
        .contact {
            margin-bottom: 0;
            margin-top: 20px;
        }
    }

    @media screen and (max-width: 611px) {
        .button-group-login {
            width: 500px;
        }

        .register-top__wrapper {
            width: 500px;
        }

        .sign-up__wrapper {
            flex-direction: column;
        }

        .input-icon__last-name {
            display: block;
            color: white;
            margin-right: 10px;
        }

        .form-lable__last-name {
            padding-left: 30px;
        }

        .sign-up__button {
            width: 400px;
        }

        .google-policy__wrapper {
            padding-right: 80px;
        }

        .button-group {
            flex-direction: column;
            margin-left: 55px;
            margin-right: 145px;
        }

        .social-group__btn {
            display: flex;
            flex-direction: column;
            margin-left: 55px;
            margin-right: 145px;
        }

        .button-group__subtitle {
            padding-left: 55px;
        }

        input[type="text"] {
            width: 288px;
        }

        .separator {
            width: 185px;
        }

        .login-form {
            width: 470px;
        }

        .forgot__button {
            margin-left: 140px;
        }

        .sign-in__form {
            padding-left: 30px;
        }

        .button-group-login button.google-btn {
            margin-bottom: 25px;
        }

        .reset-form .input-wrapper {
            margin-left: 85px;
        }
    }

    @media screen and (max-width: 503px) {
        .register-top__wrapper {
            width: auto;
        }

        .button-group-login {
            width: auto;
        }

        .social-group__btn {
            display: flex;
            flex-direction: column;
            margin-right: 65px;
        }

        .button-group-login button.google-btn {
            margin-bottom: 25px;
        }

        .sign-up__button {
            width: 340px;
        }

        .separator {
            width: 155px;
        }

        .button-group {
            display: flex;
            flex-direction: column;
        }

        .sign-in__button {
            width: 410px;
        }

        .login-form {
            width: auto;
        }

        .reset-form .input-wrapper {
            margin-left: 60px;
        }
    }

    @media screen and (max-width: 426px) {
        .button-group-login {
            width: 382px;
        }

        .sign-btn__wrapper {
            margin-right: 25px;
        }

        .social-group__btn {
            margin-right: 0px;
            margin-left: 40px;
        }

        .button-group {
            margin-left: 40px;
            margin-right: 50px;
        }

        .title-wrapper {
            margin-left: 40px;
        }

        .button-group__subtitle {
            padding-left: 40px;
        }

        .show-password {
            left: 260px;
        }

        .sign-up__button {
            padding: 12px 10px;
            width: 290px;
        }

        label {
            padding-right: 15px;
        }

        .google-policy__wrapper {
            padding-right: 40px;
        }

        .separator {
            width: 123px;
        }

        .sign-in__button {
            width: 330px;
        }

        .forgot__button {
            margin-left: 95px;
        }

        .button-group-login button.facebook-btn {
            margin-right: 16px;
        }

        .reset-form .input-wrapper {
            margin-left: 40px;
        }
        .register-content {
            margin-left: 40px;
            padding-right: 15px
        }
        .register-content__icon img {
            width: 20px !important;
            height: 20px !important;
            max-width: inherit;
        }
        .register-content__text {
            text-align: start;
        }
    }

    @media screen and (max-width: 376px) {
        .button-group-login {
            width: 335px;
        }

        .login-form {
            width: 328px;
        }

        .reset-btn {
            padding: 12px 105px;
        }

        .sign-up__form {
            padding-left: 30px;
        }

        .show-password {
            left: 235px;
        }

        .sign-in__button {
            padding: 12px 0px;
            width: 280px;
        }

        .sign-up__button {
            width: 260px;
        }

        .forgot__button {
            margin-left: 70px;
        }

        .button-group {
            margin-right: 20px;
        }

        .facebook-btn__text {
            font-size: 15px;
        }

        .google-btn__text {
            font-size: 15px;
        }
    }

    @media screen and (max-width: 320px) {
        .header-logo {
            margin-top: 14px;
            margin-bottom: 15px;
        }

        .login-form {
            width: 255px;
        }

        .register-form {
            width: 275px;
        }

        .button-group-login {
            width: 290px;
        }

        .button-group__subtitle {
            margin-right: 39px;
        }

        input[type="text"], input[type="password"], input[type="email"] {
            width: 240px;
        }

        label {
            padding-left: 0;
        }

        .sign-up__button {
            width: 240px;
            padding: 12px 10px;
        }

        #checkbox-text {
            padding-left: 30px;
        }

        .sign-in__button {
            padding: 12px 85px;
        }

        .form-lable {
            left: 27px;
        }

        .reset-btn {
            padding: 12px 80px;
        }

        .forgot__button {
            margin-left: 60px;
        }

        .contact {
            margin-top: 20px;
        }

        .language-change {
            margin-top: 10px;
        }

        .register-top__wrapper {
            width: 290px;
        }

        .sign-up__form {
            padding-left: 20px;
        }

        .show-password {
            left: 200px;
        }

        .sign-in__button {
            width: 225px;
        }

        .forgot__button {
            margin-left: 45px;
        }

        .reset-form .input-wrapper {
            margin-left: 25px;
        }

        .social-group__btn {
            margin-left: 15px;
            margin-right: 0;
        }

        .google-btn__icon {
            padding: 8px;
        }

        .facebook-btn__icon {
            padding: 8px;
        }

        .facebook-btn__text {
            font-size: 14px;
        }

        .google-btn__text {
            font-size: 14px;
        }
        .register-content {
            margin-left: 15px;
        }
    }

    .login_msg {
        margin-top: 10px;
        color: #2e2e2e !important;
    }


</style>
